import styled from 'styled-components'

import { WalletModelShort } from '@root/entities/wallet/ui'
import { Drawer } from '@root/shared/ui-kit'

import { CurrencySelectorList } from '../common/currency-selector-list'

import type { CurrencySelectorListProps } from '../common/currency-selector-list'
import type { ClassNameProps } from '@root/shared/react'
import type { DrawerProps } from '@root/shared/ui-kit'

export type CurrencySelectorDrawerProps = {
  title: string
} & Pick<DrawerProps, 'onOpenChange' | 'open'> &
  ClassNameProps &
  CurrencySelectorListProps

export const CurrencySelectorDrawer: React.FC<CurrencySelectorDrawerProps> = ({
  open,
  wallet,
  onOpenChange,
  className,
  title,
  ...props
}) => {
  return (
    <Root
      className={className}
      open={open}
      onOpenChange={onOpenChange}
      title={title}
    >
      <Content>
        <WalletContainer>
          <WalletModelShort wallet={wallet}></WalletModelShort>
        </WalletContainer>
        <CurrencySelectorList {...props} wallet={wallet} />
      </Content>
    </Root>
  )
}

const Root = styled(Drawer)`
  height: var(--max-drawer-height);
`

const Content = styled.div`
  height: 100%;
  display: grid;
  grid-template-rows: auto minmax(0, 1fr);
`

const WalletContainer = styled.div`
  display: grid;
  justify-content: center;
  margin-block: 12px 16px;
  padding-inline: 12px;
`
